const createPluginSystemActions = (project, hookSystem) => {
  return new PluginSystemActions(project, hookSystem);
};
class PluginSystemActions {
  /**
   * The Prismic project's metadata.
   *
   * @internal
   */
  _project;
  /**
   * The actions' hook system used to internally trigger hook calls.
   *
   * @internal
   */
  _hookSystem;
  constructor(project, hookSystem) {
    this._project = project;
    this._hookSystem = hookSystem;
  }
  readAllSliceModels = async () => {
    const libraryIDs = this._project.config.libraries || [];
    return (await Promise.all(libraryIDs.map(async (libraryID) => {
      const models = await this.readAllSliceModelsForLibrary({
        libraryID
      });
      return models.map((model) => {
        return {
          libraryID,
          ...model
        };
      });
    }))).flat();
  };
  readAllSliceModelsForLibrary = async (args) => {
    const { sliceIDs } = await this.readSliceLibrary({
      libraryID: args.libraryID
    });
    return await Promise.all(sliceIDs.map(async (sliceID) => {
      return await this.readSliceModel({
        libraryID: args.libraryID,
        sliceID
      });
    }));
  };
  readSliceModel = async (args) => {
    const { data: [model], errors: [cause] } = await this._hookSystem.callHook("slice:read", {
      libraryID: args.libraryID,
      sliceID: args.sliceID
    });
    if (!model) {
      throw new Error(`Slice \`${args.sliceID}\` not found in the \`${args.libraryID}\` library.`, { cause });
    }
    return model;
  };
  readSliceLibrary = async (args) => {
    const { data: [library], errors: [cause] } = await this._hookSystem.callHook("slice-library:read", {
      libraryID: args.libraryID
    });
    if (!library) {
      throw new Error(`Slice library \`${args.libraryID}\` not found.`, {
        cause
      });
    }
    return library;
  };
  readAllCustomTypeModels = async () => {
    const { ids } = await this.readCustomTypeLibrary();
    return await Promise.all(ids.map(async (id) => {
      return this.readCustomTypeModel({ id });
    }));
  };
  readCustomTypeModel = async (args) => {
    const { data: [model], errors: [cause] } = await this._hookSystem.callHook("custom-type:read", {
      id: args.id
    });
    if (!model) {
      throw new Error(`Custom type \`${args.id}\` not found.`, { cause });
    }
    return model;
  };
  readCustomTypeLibrary = async () => {
    const { data: [library], errors: [cause] } = await this._hookSystem.callHook("custom-type-library:read", void 0);
    if (!library) {
      throw new Error(`Couldn't read custom type library.`, {
        cause
      });
    }
    return library;
  };
}
export {
  PluginSystemActions,
  createPluginSystemActions
};
//# sourceMappingURL=createPluginSystemActions.js.map
